import { type BaseApiContract } from "shared/api/BaseApiContract";
import { HttpMethod } from "shared/api/http";
import {
  type PostSocietySubmissionReviewVoteParamsInput,
  type PostSocietySubmissionReviewVoteBodyInput,
} from "shared/api/types/society/[societyId]/review/instance/[reviewInstanceId]/assignment/[assignmentId]/vote";
import { type ReviewInstanceVoteView } from "shared/mappers/database/submission/review/review-instance-vote";
export const postSocietyReviewInstanceAssignmentVoteContract: BaseApiContract<
  PostSocietySubmissionReviewVoteParamsInput,
  PostSocietySubmissionReviewVoteBodyInput,
  ReviewInstanceVoteView
> = {
  method: HttpMethod.POST,
  apiRoute:
    "/api/v1/society/[societyId]/review/instance/[reviewInstanceId]/assignment/[assignmentId]/vote",
  paramsType: {} as PostSocietySubmissionReviewVoteParamsInput,
  bodyType: {} as PostSocietySubmissionReviewVoteBodyInput,
  responseType: {} as ReviewInstanceVoteView,
};
